import { RightOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import { tolgee } from 'services/i18n/tolgee';

export const NegativeReviewNotificationMessage = (props: { name: string }) => {
  const { name } = props;

  return <>{tolgee.t('review.x收到1个中差评通知', { x: name })}</>;
};

export const NegativeReviewNotificationDescription = (props: { onClick: () => void }) => {
  const { onClick } = props;

  return (
    <Button type="link" onClick={onClick}>
      {tolgee.t('review.点击查看')}
      <RightOutlined />
    </Button>
  );
};

export const ClickViewDescription = (props: {}) => {
  return (
    <Space style={{ color: '#40a9ff' }}>
      {tolgee.t('review.点击查看')} <RightOutlined />
    </Space>
  );
};
